import column from '../../../../common/list-table/helpers/columns';

export default (data, userRole, onRowDelete, onRowEdit) => {
  const { FilteredTextColumn, FilteredNullableBooleanColumn, ActionColumn } = column(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Contact ID', 'id').withShow(false),
        new FilteredTextColumn('First Name', 'firstName').withWidth(250),
        new FilteredTextColumn('Last Name', 'lastName').withWidth(250),
        new FilteredTextColumn('Phone', 'phoneNumber').withWidth(200),
        new FilteredTextColumn('E-mail', 'emailAddress').withWidth(480),
        new FilteredNullableBooleanColumn('Notify for failure', 'notifyOnFailure').withWidth(180),
        new ActionColumn([['DELETE', 'id', onRowDelete, true], ['EDIT', 'id', onRowEdit, true]]).withShow(userRole === 'IPC_ADMIN').withWidth(100),
      ],
    },
  ];
};
